import { z } from 'zod'

/**
 * Dropship Queue contract (Screen 1). Pinned to the backend's GET /api/queue
 * response — the backend is being built to this exact shape in parallel.
 *
 * kh_value is a decimal STRING on the wire; keep it a string here and format it
 * for display without parsing to float (no display-math on money).
 */
export const queueOrderSchema = z.object({
  shopify_order_id: z.string(),
  order_number: z.string(),
  customer_name: z.string(),
  is_vip: z.boolean(),
  kh_item_count: z.number(),
  kh_value: z.string(),
  order_date: z.string(),
  eligible_count: z.number(),
  kh_skus: z.array(z.string()),
})
export type QueueOrder = z.infer<typeof queueOrderSchema>

export const queueResponseSchema = z.object({
  orders: z.array(queueOrderSchema),
  generated_at: z.string(),
})
export type QueueResponse = z.infer<typeof queueResponseSchema>
